import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import esES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PermisosProvider } from './context/PermisosContext';
import { pujaTheme } from './theme/pujaTheme';
import './index.css';

// Configurar dayjs en español
dayjs.locale('es');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ConfigProvider locale={esES} theme={pujaTheme}>
        <AntApp>
          <AuthProvider>
            <PermisosProvider>
              <App />
            </PermisosProvider>
          </AuthProvider>
        </AntApp>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
